"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const vasat_1 = require("vasat");
const _4d_objects_1 = require("./4d-objects");
const _4d_processor_service_1 = require("./4d-processor.service");
/* TODO: update links to Vasat documentation. (find and replace: linkToVasat ) */
/**
 * <p>Service containing useful methods to communicate with server.</p>
 */
class FourDService {
    constructor(V) {
        this.V = V;
        this.playground = [];
        this.FILTER_PLOTABLE = "plotable";
        this.FILE_UPLOADED = "file_uploaded";
        this.FILE_FAILED = "file_failed";
        this.FILE_CNX = "file_cnx";
        this.FILE_ADDED = "file_added";
        this.FILE_BEFORE_UL = "file_before";
        this.FILE_PROGRESS = "file_prog";
        this.activeWidgets = [];
        this.filters = {};
        this.uploadChunkSize = 5000000;
        this.runningTasks = [];
        this.runningTasksMap = {};
        this.uploadsRunning = [];
        this.uploadsRunningMap = {};
        this.uploadsQueued = [];
        this.uploadsQueuedMap = {};
        this._runningTaskSubject = new rxjs_1.Subject();
        this.runningTasksObservable = this._runningTaskSubject.asObservable();
        this._uploadsRunningSubject = new rxjs_1.Subject();
        this.uploadsRunningObservable = this._uploadsRunningSubject.asObservable();
        this._accountChangeSubject = new rxjs_1.Subject();
        this.accountChangeObservable = this._accountChangeSubject.asObservable();
        this._socketSubject = new rxjs_1.Subject();
        this._socketObservable = this._socketSubject.asObservable().pipe(operators_1.debounceTime(30000));
        this._socketCommands = {};
        // debug
        this._socketObservable.subscribe((item) => console.log(item));
        this.onSocketCommand('welcome').subscribe(s => s.running.forEach(i => {
            if (i.lastProgress) {
                var v = new _4d_processor_service_1.ServerProcess();
                Object.keys(i.lastProgress).forEach(k => v[k] = i.lastProgress[k]);
                this.addTask(v);
            }
        }));
    }
    /**
     * <p>Logout of current user.</p>
     */
    logout() {
        return this.V.logoutObservable().pipe(operators_1.map(s => this.clearStates()));
    }
    /**
     * <p>Removes active team.</p>
     */
    clearStates() {
        this.teams = null;
        this.activeTeam = null;
        this.activeUser = null;
        this._accountsObservale = null;
        this.deinitSocket();
    }
    onV2Init() {
        return this.onReady().pipe(operators_1.flatMap(res => {
            if (!this.datasetTypes) {
                return this.V.searchByObject(_4d_objects_1.TransformType).useCache(true).limit(101).queryObservable()
                    .pipe(operators_1.flatMap((t) => {
                    this.transformTypes = t.items;
                    return this.V.searchByObject(_4d_objects_1.DatasetType).useCache(true).limit(102).queryObservable();
                }), operators_1.flatMap(ds => {
                    this.datasetTypes = ds.items;
                    this.filters[this.FILTER_PLOTABLE] = this.datasetTypes.filter(d => d.canPlot);
                    return rxjs_1.forkJoin(this.V.searchByObject(_4d_objects_1.ProcessorAPI).useCache(true).equals('active', true).queryObservable().pipe(operators_1.map((t) => this.apis = t.items)), this.V.searchByObject(_4d_objects_1.JobType).useCache(true).equals('active', true).queryObservable().pipe(operators_1.map((t) => this.jobTypes = t.items)));
                    // map transforms to the local instance
                    //ds.items.forEach(dsi => {
                    //  dsi.adhocTransforms = dsi.adhocTransforms.map(t => this.transformTypes.find(tt =>  tt.id == t.id))
                    //  dsi.autoApplyTransforms = dsi.autoApplyTransforms.map(t => this.transformTypes.find(tt => tt.id == t.id))
                    //})
                }));
            }
            else {
                rxjs_1.of(res);
            }
        }));
    }
    getQuotas() {
        return this.V.api('/api/Account/' + this.activeTeam.id + '?quota=true');
    }
    /**
     * <p>Returns an observable of an [[Account]] object. If it does not have a team or get sample [[Account]].</p>
     * <footer>Note: throws exception if not logged in.</footer>
     */
    onReady() {
        if (this.teams) {
            return rxjs_1.of(this.teams);
        }
        else if (this._accountsObservale) {
            return this._accountsObservale;
        }
        else {
            return this._accountsObservale = this.V.onReady().pipe(operators_1.flatMap(s => {
                this.activeUser = s ? s.user : null;
                if (!s) {
                    this.clearStates();
                    throw "Not logged in";
                }
                else {
                    if (!this.socket)
                        this.initSocket(s);
                    this.onSocketCommand('update_dataset').subscribe(tc => {
                        var ds = this.V.findCached(_4d_objects_1.Dataset, tc.id);
                        if (ds)
                            ds.set(tc);
                    });
                    this.onSocketCommand('task_update').subscribe(tc => {
                        let task = this.runningTasksMap[tc.dataset.id];
                        var isFinished = tc.status == 'finished' || tc.status == 'error';
                        if (task) {
                            task.update(tc);
                            if (isFinished)
                                this.removeTask(tc, tc.status == 'error');
                            else
                                this._runningTaskSubject.next({
                                    event: 'update',
                                    task: task,
                                    finished: isFinished,
                                    error: tc.status == 'error'
                                });
                        }
                        else if (!isFinished) {
                            let t = new _4d_processor_service_1.ServerProcess();
                            t.update(tc);
                            this.addTask(t);
                        }
                    });
                    return rxjs_1.forkJoin([
                        this.V.searchByObject(_4d_objects_1.AccountPlan).useCache(true).equals('active', true).queryObservable().pipe(operators_1.map((t) => this.plans = t.items)),
                        this.V.searchByObject(vasat_1.Role).useCache(true).equals('active', true).limit(104).queryObservable().pipe(operators_1.map((t) => this.roles = t.items)),
                        this.V.api("/4dinfo").pipe(operators_1.tap(config => this.domainConfig = config)),
                        this.V.searchByObject(_4d_objects_1.Account).useCache(true).limit(105).queryObservable().pipe(operators_1.map(r => {
                            this._accountsObservale = null;
                            this.V.registerCacheClass(_4d_objects_1.Account, r.items);
                            this.V.registerClass(_4d_objects_1.Dataset);
                            this.V.registerClass(_4d_objects_1.JobType);
                            this.V.registerClass(_4d_objects_1.Job);
                            this.V.registerClass(_4d_objects_1.JobBatch);
                            this.V.registerClass(_4d_objects_1.DatasetType);
                            this.V.registerClass(_4d_objects_1.Transform);
                            this.V.registerClass(_4d_objects_1.Project);
                            this.V.registerClass(_4d_objects_1.TransformType);
                            this.V.registerClass(_4d_objects_1.Annotation);
                            //this.V.registerClass(Widget)
                            this.V.registerClass(_4d_objects_1.EPSGCodes);
                            this.domain = r.items.find(a => a.isDomain);
                            this.rootAccounts = r.items.filter(a => !a.parent && a.uid != 'sample' && !a.closed);
                            this.sampleAccount = r.items.find(a => a.uid == 'sample' && a.active);
                            return this.teams = r.items.filter(a => a.uid != 'sample');
                        }))
                    ]);
                }
            }), operators_1.share());
        }
    }
    /**
     * <p>If [[ServerProcess]] is not already running, add it. Otherwise update it.</p>
     * @param t The [[ServerProcess]] to add.
     */
    addTask(t) {
        if (this.runningTasksMap[t.dataset.id]) {
            t = this.runningTasksMap[t.dataset.id].update(t);
        }
        else {
            this.runningTasks.push(t);
            this.runningTasksMap[t.dataset.id] = t;
            this._runningTaskSubject.next({
                event: 'add',
                task: t,
                finished: false,
                error: false
            });
        }
    }
    /**
     * Remove the [[ServerProcess]] task.
     * @param task The task to remove.
     * @param err if the task ended in error set to true.
     */
    removeTask(task, err) {
        delete this.runningTasksMap[task.dataset.id];
        this.runningTasks = this.runningTasks.filter(t => t.dataset.id != task.dataset.id);
        this._runningTaskSubject.next({
            event: 'remove',
            task: task,
            finished: true,
            error: !!err
        });
    }
    /**
     * <p>Uploads file using [[ChunkedFileUploader]].</p>
     * @param ds [[Dataset]] to upload associated file.
     * @param f File to be uploaded.
     * @param filename Name of file.
     * @param chunkSize Size of chunks when uploading.
     */
    uploadFile(ds, f, filename = 'data', chunkSize) {
        var c = new _4d_processor_service_1.ChunkedFileUploader(this.V, this.V.config.host + '/api/Dataset/' + ds.id + '.chunked/' + filename, chunkSize || this.uploadChunkSize);
        c.fileRef = f;
        var task = new _4d_processor_service_1.ServerProcess();
        task.dataset = ds;
        task.uid = '' + ds.id;
        task.status = 'uploading';
        task.name = 'UPLOAD';
        task.progress = ds.incomplete ? ds.incomplete_offset / ds.incomplete_total : 0;
        task.uploader = c;
        var sub = c.progressObservable.subscribe(s => task.progress = s);
        this.uploadsQueued.push(task);
        this.uploadsQueuedMap[task.dataset.id] = task;
        setTimeout(() => this._deQueue(), 100);
        return task;
    }
    _deQueue() {
        if (this.uploadsRunning.length < 4 && this.uploadsQueued.length) {
            var next = this.uploadsQueued[0];
            var queue = next.uploader.uploadObservable(next.uploader.fileRef, next.dataset.incomplete ? next.dataset.incomplete_offset : 0, next.dataset.incomplete ? next.dataset.incomplete_seq : 0);
            this.uploadsRunning.push(next);
            this.uploadsRunningMap[next.dataset.id] = next;
            this.uploadsQueued = this.uploadsQueued.filter(q => q != next);
            delete this.uploadsQueuedMap[next.dataset.id];
            this._uploadsRunningSubject.next({
                task: next,
                finished: false,
                event: 'start',
                error: false
            });
            queue.subscribe(s => {
                var me = this.uploadsRunning.find(u => u.uploader == s.chunk);
                this.uploadsRunning = this.uploadsRunning.filter(r => r != me);
                delete this.uploadsRunningMap[me.dataset.id];
                this._uploadsRunningSubject.next({
                    task: me,
                    finished: true,
                    event: 'finished',
                    error: false
                });
                this._deQueue();
            }, e => {
                var me = this.uploadsRunning.find(u => u.uploader == next.uploader);
                this.uploadsRunning = this.uploadsRunning.filter(r => r != me);
                delete this.uploadsRunningMap[me.dataset.id];
                if (me.error && e.error)
                    me.error(e.error);
                this._uploadsRunningSubject.next({
                    task: me,
                    finished: true,
                    event: 'error',
                    error: true
                });
                this._deQueue();
            });
        }
    }
    /**
     * <p>Queries for <a href="https://docs.vasat.io/">Vasat</a> Model class and returns a <a href=" linkToVasat ">VasatSeachQuery</a>.</p>
     * @param objectType The Vasat model you want to query for.
     */
    searchFor(objectType) {
        return this.V.searchByObject(objectType);
    }
    /**
     * <p>Returns observable of [[Account]] if it exists. Else throws exception.</p>
     */
    onActiveAccountReady() {
        if (this._activeAccountObservable)
            return this._activeAccountObservable;
        else if (this.activeTeam) {
            return rxjs_1.of(this.activeTeam);
        }
        else
            return this.accountChangeObservable.pipe(operators_1.take(1));
    }
    /**
     * <p>Note that this is for advanced users with multiple teams. If you are a single user this does not apply.</p>
     * <p>Sets the active team to given accountId, so all subsequent api calls that are made will return things that only this accountId can see.</p>
     * @param accountId
     */
    setActiveTeam(accountId) {
        this.tryingAccount = accountId;
        this.V.registerCacheClass(_4d_objects_1.TransformType, []);
        this.V.registerCacheClass(_4d_objects_1.DatasetType, []);
        if (this.activeTeam && this.activeTeam.uid == accountId) {
            return rxjs_1.of(this.activeTeam);
        }
        else if (!accountId) {
            this.V.pathPrefix = '/api';
            this.activeTeam = null;
            this._activeAccountObservable = null;
            return rxjs_1.of(this.activeTeam);
        }
        else if (this._activeAccountObservable) {
            return this._activeAccountObservable;
        }
        else {
            return this._activeAccountObservable = this.onReady().pipe(operators_1.flatMap(aa => {
                let res = aa.find(a => a.uid == accountId);
                if (res) {
                    this.activeTeam = res;
                    this.V.pathPrefix = '/app/Account/' + accountId + '/api';
                    console.log("Active Account Set Prefix " + this.V.pathPrefix);
                    // load the transform types first then the dataset types
                    return this.V.searchByObject(_4d_objects_1.TransformType).useCache(true).limit(106).queryObservable()
                        .pipe(operators_1.flatMap((t) => {
                        this.transformTypes = t.items;
                        return this.V.searchByObject(_4d_objects_1.DatasetType).useCache(true).limit(107).queryObservable();
                    }), operators_1.map(ds => {
                        this.datasetTypes = ds.items;
                        this.filters[this.FILTER_PLOTABLE] = this.datasetTypes.filter(d => d.canPlot);
                        return ds.items;
                        // map transforms to the local instance
                        //ds.items.forEach(dsi => {
                        //  dsi.adhocTransforms = dsi.adhocTransforms.map(t => this.transformTypes.find(tt =>  tt.id == t.id))
                        //  dsi.autoApplyTransforms = dsi.autoApplyTransforms.map(t => this.transformTypes.find(tt => tt.id == t.id))
                        //})
                    }), operators_1.flatMap(_ => {
                        return this.V.searchByObject(_4d_objects_1.Tag).useCache(true).limit(108).queryObservable().pipe(operators_1.tap(res => this.tags = res.items));
                    }), operators_1.flatMap(_ => {
                        var obsList = [
                            this.V.searchByObject(_4d_objects_1.ProcessorAPI).useCache(true).equals('active', true).queryObservable().pipe(operators_1.map((t) => this.apis = t.items)),
                            this.V.searchByObject(_4d_objects_1.JobType).useCache(true).equals('active', true).queryObservable().pipe(operators_1.map((t) => this.jobTypes = t.items)),
                            this.V.searchByObject(_4d_objects_1.Project).useCache(true).equals('active', true).limit(109).queryObservable().pipe(operators_1.map((t) => this.projects = t.items))
                        ];
                        // Check if account has plan
                        if (this.activeTeam.plan) {
                            obsList.push(this.activeTeam.plan.availableWidgets.useCache(true).equals('active', true).limit(110).queryObservable().pipe(operators_1.map((t) => this.activeWidgets = t.items)));
                        }
                        return rxjs_1.forkJoin(obsList);
                    }), operators_1.map(done => {
                        this._accountChangeSubject.next(res);
                        this._activeAccountObservable = null;
                        return res;
                    }));
                }
                else {
                    this.V.pathPrefix = '/api';
                    throw "Invalid account ID " + accountId;
                }
            }), operators_1.share());
        }
    }
    /**
     * <p>Initialise WebSocket.</p>
     * @param s
     */
    initSocket(s) {
        if (this.socket)
            return;
        try {
            this.runningTasks = [];
            this.runningTasksMap = {};
            this.socket = new WebSocket(this.V.config.host
                .replace('https://', 'wss://')
                .replace('http://', 'ws://') + "/socket?access_token=" + s.access_token);
            this.socket.onopen = (ev) => this.socketUp = true;
            this.socket.onmessage = (ev) => {
                try {
                    let obj = JSON.parse(ev.data);
                    this._socketSubject.next(obj);
                    if (obj.cmd && this._socketCommands[obj.cmd]) {
                        this._socketCommands[obj.cmd].subject.next(obj.payload);
                    }
                    if (this._socketCommands['*']) {
                        this._socketCommands['*'].subject.next(obj.payload);
                    }
                    if (this._socketCommands['*!']) {
                        this._socketCommands['*!'].subject.next(obj);
                    }
                }
                catch (e) {
                    this._socketSubject.error(e);
                }
            };
            this.socket.onerror = (ev) => {
                this.retrySocket(s, ev);
            };
            this.socket.onclose = (ev) => {
                this.retrySocket(s, ev);
            };
        }
        catch (e) {
            this.retrySocket(s, e);
        }
    }
    /**
     * <p>Try to reinitialise WebSocket.</p>
     * @param s An active <a href=" linkToVasat ">Vasat Session</a>.
     * @param e Error or exception.
     */
    retrySocket(s, e) {
        this.socket = null;
        this.socketUp = false;
        this._socketSubject.error(e);
        setTimeout(() => this.initSocket(s), 10000);
    }
    /**
     * <p>Close WebSocket.</p>
     */
    deinitSocket() {
        if (this.socket) {
            this.socket.close();
            this.socket = null;
            this.socketUp = false;
        }
    }
    /**
     * <p>If command does not exist, create one and return.</p>
     * @param cmd Socket command.
     */
    onSocketCommand(cmd) {
        let obj = this._socketCommands[cmd];
        if (!obj) {
            let subj = new rxjs_1.Subject();
            let obs = subj.asObservable(); //.pipe(debounceTime(30000))
            obj = { subject: subj, obs: obs };
            this._socketCommands[cmd] = obj;
        }
        return obj.obs;
    }
    /**
     * <p>Transmist data to server.</p>
     * @param a Data to send.
     */
    sendSocket(a) {
        if (this.socket)
            if (typeof a == "string")
                this.socket.send(a);
            else
                this.socket.send(JSON.stringify(a));
        else
            console.error("Socket closed for sending " + a);
    }
    /**
     * <p>Return [[ProcessorAPI]] of given type.</p>
     * @param apiType The type of transformation from this API.
     */
    getApi(apiType) {
        return this.apis.find(ele => ele.type == apiType);
    }
    /**
     *
     * @param folderId retun the chain of folders going up to the root folder for the specified folder Id
     */
    getFolderChain(folderId, cache = true) {
        return this.V.searchByObject(_4d_objects_1.Folder).equals("chainBy", folderId).useCache(cache).queryObservable().pipe(operators_1.map(s => {
            if (s.items.length) {
                var base = s.items.find(ff => ff.id == folderId);
                var f = base;
                var chain = [base];
                while (f.parent) {
                    f = s.items.find(ff => ff.id == f.parent.id);
                    chain.push(f);
                }
                return chain;
            }
        }));
    }
}
exports.FourDService = FourDService;
/**
 * <p>Base component class to extend that initialises common properties, and calls [[onReady]] when initialising is finished.</p>
 */
class BaseComponent {
    constructor(_4D, _account = null) {
        this._4D = _4D;
        this._account = _account;
        this.loading = false;
    }
    /**
     * <p>Initialises some properties that will be commonly used among your components.</p>
     */
    ngOnInit() {
        this.sub = this._4D.onReady().pipe(operators_1.flatMap(aa => {
            if (this._account)
                return this._4D.setActiveTeam(this._account);
            else if (this._4D.tryingAccount)
                return this._4D.onActiveAccountReady();
            else
                return rxjs_1.of(aa[0]);
        })).subscribe(s => {
            let ls = this._4D.V.localSession();
            this.activeUser = ls ? ls.user : null;
            this.onReady();
        });
    }
    /**
     * <p>This is called when initialisation has finished. Your components should do their initialisation here.</p>
     */
    onReady() {
    }
    /**
     * <p>Unsubscribes from subscription when component destroyed.</p>
     */
    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
exports.BaseComponent = BaseComponent;
